import { render, staticRenderFns } from "./TherapyEvaluate.vue?vue&type=template&id=4713dc17"
import script from "./TherapyEvaluate.vue?vue&type=script&lang=js"
export * from "./TherapyEvaluate.vue?vue&type=script&lang=js"
import style0 from "./TherapyEvaluate.vue?vue&type=style&index=0&id=4713dc17&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\daima\\daima\\health-store\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4713dc17')) {
      api.createRecord('4713dc17', component.options)
    } else {
      api.reload('4713dc17', component.options)
    }
    module.hot.accept("./TherapyEvaluate.vue?vue&type=template&id=4713dc17", function () {
      api.rerender('4713dc17', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/page/evaluate/TherapyEvaluate.vue"
export default component.exports